<template>
  <Dialog v-model:visible="visible">
    <template #header>
      <h3>{{ _t('ALARM_PANEL') }} : {{ _t('Delete') }}</h3>
    </template>
    <p><strong class="color-green">{{ panelName }}</strong>: {{ _t('label_delete_record') }}</p>
    <template #footer>
      <Button :label="_t('Cancel')" class="p-button-text" icon="pi pi-times" @click="$emit('cancel')"/>
      <Button :label="_t('Delete')" autofocus icon="pi pi-check" @click="$emit('confirm')"/>
    </template>
  </Dialog>
</template>

<script>
export default {
  name: 'DeleteAlarmPanelDialog',
  props: {
    modelValue: { type: Boolean, required: true },
    panelName: { type: String, default: '' },
  },
  emits: ['update:modelValue', 'confirm', 'cancel'],
  computed: {
    visible: {
      get() { return this.modelValue },
      set(v) { this.$emit('update:modelValue', v) },
    },
  },
}
</script>
